import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import '../../../_base/_assets/sass/pages/login/login-1.scss';
import { AuthTabs } from './components';
import { toAbsoluteUrl } from '../../../_base';
import Logo from './components/icons/Logo';

export const AuthPage: React.FC = () => {

  return (
    <div
      className='kt-grid kt-grid--ver kt-grid--root'
      style={{
        minHeight: '100vh',
        maxHeight: '100vh',
        overflowY: 'auto',
      }}
    >
      <div id='kt_login' className='kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1'>
        <div className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile'>
        <div
            className='kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside'
            style={{
              backgroundImage: `url(${toAbsoluteUrl('/media/bg/bg-4.jpg')})`,
            }}
          >
            <div
              className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver'
              style={{ marginBottom: '7rem' }}
            >
              {/* <div className='kt-grid__item kt-grid__item--top'>
                <h3 className='kt-login__title'>
                  {intl.formatMessage({ id: 'AUTH.WELCOME.TITLE' }).toUpperCase()}
                </h3>
                <h4 className='kt-login__subtitle'>
                  {intl.formatMessage({ id: 'AUTH.WELCOME.SUBTITLE' })}
                </h4>
              </div> */}
            </div>
          </div>


      
          <div className='kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper'>
            <div  className='kt-login__head'>
              <Logo />
            </div>

            <Routes>
              <Route index path='main' element={<AuthTabs />} />
              <Route path='*' element={<Navigate to='/auth/main' />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};
